export const Functions = {
  create: false,
  delete: false,
  detail: false,
  search: false,
};

export const PageName = '优先兑换列表';
